import axios from "axios";
import { supabase } from "./supabaseClient";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const QUOTES_GET_URL = `${SUPABASE_URL}/functions/v1/quotes-get`;

export async function fetchQuotesServer(symbols, userId, accessToken, extraParams = {}) {
  const params = new URLSearchParams();
  params.set("symbols", symbols.join(","));
  if (userId) params.set("user_id", userId);
  // optional flags e.g. { force: true, validate: true }
  for (const [k, v] of Object.entries(extraParams)) {
    if (v === true) params.set(k, "1");
    else if (v != null) params.set(k, String(v));
  }

  const { data } = await axios.get(`${QUOTES_GET_URL}?${params.toString()}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return data || {};
}

export async function fetchSeriesServer(symbol, { range = "6mo", interval = "1d" } = {}, accessToken) {
  const SUPABASE_URL =
    process.env.REACT_APP_SUPABASE_URL ||
    window.__SUPABASE_URL__ ||           // if you attach it globally anywhere
    window.location.origin;

  let token = accessToken;
  if (!token) {
    const { data: { session } } = await supabase.auth.getSession();
    token = session?.access_token || process.env.REACT_APP_SUPABASE_ANON_KEY || "";
  }

  const url = `${SUPABASE_URL}/functions/v1/series-get?symbol=${encodeURIComponent(symbol)}&range=${range}&interval=${interval}`;

  const res = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`series-get ${res.status} ${txt}`);
  }
  const json = await res.json();

  // normalize: must be an array of [ms, close]
  if (!Array.isArray(json.series)) {
    throw new Error("series-get returned no series");
  }
  return json;
}